import * as React from 'react'
import { ProgrammeSession } from './Programme'
import SessionCard from './Session/SessionCard'

interface HallSessionsProps {
  displayHallName: string // Renamed for clarity
  originalHallName: ProgrammeSession['hall'] // Added original name
  programmes: Array<ProgrammeSession>
  activeHall: ProgrammeSession['hall']
  getTabColor: any
}

const HallSessions: React.FC<HallSessionsProps> = ({
  displayHallName,
  originalHallName, // Destructure new prop
  programmes,
  activeHall,
  getTabColor,
}) => {
  const active = activeHall === originalHallName // Use original name for active check
  const pastSessions = programmes?.filter(
    (s) => s.durationInSeconds + s.secondsTillStart < 0
  )
  const upcomingSessions = programmes?.filter(
    (s) => s.durationInSeconds + s.secondsTillStart >= 0
  )

  return (
    <div className={`hallContainer ${active && 'd-block'} d-md-block`}>
      <div className="d-flex d-none d-md-block">
        <div
          className="hallTabs text-center fw-bold"
          style={{ background: getTabColor(originalHallName) }} // Use original name for color
        >
          {displayHallName} {/* Use display name for text */}
        </div>
      </div>
      <div
        className={`sessionContainer p-0 p-md-3`}
        style={{ background: '#D1EAFF' }}
      >
        {programmes?.map((session) => (
          <SessionCard key={session.id} {...session} hall={originalHallName} /> // Pass original hall name to SessionCard
        ))}
        {/* {upcomingSessions?.map((session) => (
          <SessionCard key={session.id} {...session} />
        ))}
        {pastSessions?.map((session) => (
          <SessionCard ended key={session.id} {...session} />
        ))} */}
      </div>
    </div>
  )
}

export default HallSessions
